export default {"src":"/_next/static/media/highcontrast-close.682d3d99.svg","height":25,"width":24};